import React from 'react';

const ErrorDisplay = ({ error, onRetry }) => (
  <div className="bg-red-50 border border-red-200 rounded p-6 text-center">
    <p className="text-red-600 mb-4 text-sm">Failed to load SMS conversations: {error}</p>
    <button 
      onClick={onRetry}
      className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded text-sm font-bold"
    >
      Retry
    </button>
  </div>
);

export default ErrorDisplay;